interface PoiLike {
  name: string;
  category_name?: string | null;
}

/** Format a POI into a label, optionally suffixing the category name.
 *  Returns null when the POI is falsy so call sites can short-circuit. */
export function formatPoiLabel(poi: PoiLike | null | undefined): string | null {
  if (!poi) return null;
  return poi.category_name ? `${poi.name} (${poi.category_name})` : poi.name;
}
